import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentError: null,
  errorSource: null,
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError(state, action) {
      const { error, source } = action.payload;
      state.currentError = error.toString();
      state.errorSource = source;
    },
    clearError(state) {
      state.currentError = null;
      state.errorSource = null;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;

export default errorSlice.reducer;
